export const state = {
	allTeams: [],
	selectedTeamId: "",
};
